import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';
import { useLoader } from '../context/loaders/useLoader';
import { useToast } from '../context/toasts/useToast';
import { Label } from '../types/kanban';

export function useLabels(boardId: number) {
  const [labels, setLabels] = useState<Label[]>([]);
  const [error, setError] = useState<Error | null>(null);

  const { getLabels } = useApi();
  const { withLoader } = useLoader();
  const { addNotification } = useToast();

  const fetchLabels = useCallback(async () => {
    try {
      setError(null);
      const data = await withLoader(() => getLabels(boardId), 'Loading labels...');
      setLabels(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to load labels';
      setError(err instanceof Error ? err : new Error(errorMessage));
      addNotification({
        type: 'error',
        title: 'Error Loading Labels',
        message: errorMessage,
        duration: 5000,
      });
      return [];
    }
  }, [boardId, getLabels, withLoader, addNotification]);

  useEffect(() => {
    if (boardId) {
      fetchLabels();
    }
  }, [boardId, fetchLabels]);

  return {
    labels,
    error, // For debugging, not for UI display
    loading: false, // Loading is handled by global loader
    refetch: fetchLabels,
  };
}
